import { Office, ResourceType, UserRoles } from "@gettactic/api";
import { getMaxDateAllowedToReserve } from "./getMaxDateAllowedToReserve";
import { getMinDateAllowedToReserve } from "./getMinDateAllowedToReserve";
import { convertTZ } from "../date-time/convertTZ";

export function isAllowedToReserve(
  day: Date,
  officeTimezone: string,
  office: Office | undefined,
  resType: ResourceType,
  roles: UserRoles[] = [],
  extraDays?: number
) {
  const max = getMaxDateAllowedToReserve(
    officeTimezone,
    office,
    resType,
    extraDays
  );
  const min = getMinDateAllowedToReserve(officeTimezone);

  const dayInOfficeTz = convertTZ(day, officeTimezone);

  if (!roles.includes("owner") && dayInOfficeTz.getTime() < min.getTime()) {
    return false;
  }
  if (max && dayInOfficeTz.getTime() > max.getTime()) {
    return false;
  }
  return true;
}
